import Modal from "components/Modal";
import { FormProvider } from "react-hook-form";
import { TextInputFormProvider } from "components/TextInputFormProvider";
import { KommunkodDropdown } from "components/KommunkodDropdown";
import Divider from "components/Divider";
import { PatchFacilityLogicRetVal } from "./usePatchFacilityLogic.hook";
import { ModalPrimaryButton, ModalSecondaryAction } from "./AddFacilityModal";
import { TextAreaFormProvider } from "components/TextAreaFormProvider";
import SecondaryButton from "components/buttons/SecondaryButton";
import { Tips } from "components/Tips";

type Props = {
  logic: PatchFacilityLogicRetVal;
};
export const PatchFacilityModal = ({ logic }: Props) => {
  const postnummer = logic.form.watch("postalCode");
  return (
    <Modal
      isOpen={logic.isModalOpen}
      title={"Redigera anläggning"}
      actionText="Spara"
      onClose={logic.onModalClose}
      afterClose={logic.afterModalClose}
      isLoading={logic.mutation.isPending}
      loadingText="Sparar..."
      hideButtons
      isWide
    >
      <FormProvider {...logic.form}>
        <form className="mt-4 pt-4" onSubmit={logic.onSubmit}>
          <div className="mt-2 grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-4">
            <TextInputFormProvider
              required
              label="Anläggningens namn"
              name="name"
              labelClassName="font-semibold"
            />
            <div className="hidden sm:block"></div>
            <TextInputFormProvider
              label="Epostadress för rapporter"
              name="documentationEmail"
              labelClassName="font-semibold"
              info="Behöver bara anges om den skiljer sig från kundens"
            />
            <div className="hidden sm:block"></div>
          </div>
          <Divider className="mb-4 mt-6" />
          <h4 className="flex items-center justify-between text-sm font-bold text-gray-950">
            Adressuppgifter
            <SecondaryButton size="small" onClick={logic.copyCustomerAddress}>
              Kopiera från kund
            </SecondaryButton>
          </h4>
          <div className="mb-4 mt-2 grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-4">
            <TextInputFormProvider label="Gata och gatunummer" name="address" />
            <TextInputFormProvider label="Postnummer" name="postalCode" />
            <TextInputFormProvider label="Postort" name="city" />
            <KommunkodDropdown
              postnummer={postnummer}
              name="kommunKod"
              register={logic.form.register}
              setKommunKod={(k) => logic.form.setValue("kommunKod", k)}
              errorMessage={logic.form.formState.errors?.kommunKod?.message}
            />
            <TextInputFormProvider
              label="CFAR-nummer (för ombudsrapportering)"
              name="cfarNr"
            />
            <div></div>
          </div>
          <Tips
            className="mb-4"
            id="793e06be-66de-4a19-b8a4-1174c9a7b77e"
            paragraphs={[
              "Om platsen saknar adress kan du istället ange en exakt position med koordinater. För rapportering till Avfallsregistret krävs antingen adress eller koordinater. Öppna Google Maps, högerklicka på platsen och klicka på koordinaterna så kopieras de till urklipp. Klistra sedan in dem nedan. ",
            ]}
          />
          <TextInputFormProvider
            name="coordinates"
            label="Koordinater"
            placeholder="xx.xxxxxxxxxxxxxxx, yy.yyyyyyyyyyyyyyy"
            link="https://www.google.se/maps/"
            linkLabel="Öppna Google Maps"
          />

          <Divider className="mb-4 mt-6" />

          <h4 className="mt-6 flex items-center justify-between text-sm font-bold text-gray-950">
            Kontaktperson
            <SecondaryButton size="small" onClick={logic.copyCustomerContact}>
              Kopiera från kund
            </SecondaryButton>
          </h4>

          <div className="mt-2 grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-4">
            <TextInputFormProvider label="Namn" name="contactName" />
            <TextInputFormProvider label="Telefon" name="contactPhone" />
            <TextInputFormProvider label="Epost" name="contactEmail" />
          </div>
          <Divider className="mb-4 mt-6" />
          <div className="mt-2 grid grid-cols-1 gap-4 sm:grid-cols-2">
            <TextAreaFormProvider label="Anteckningar" name="notes" rows={3} />
            <div></div>
          </div>
          <Divider className="mb-4 mt-6" />
          <div className="flex justify-end">
            <div className="flex w-96 gap-x-2">
              <ModalSecondaryAction onClick={logic.onModalClose} />
              <ModalPrimaryButton
                isLoading={logic.mutation.isPending}
                buttonText="Spara"
                loadingText="Sparar"
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </Modal>
  );
};
